<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row form-group">
        <label class="col-form-label col-md-4 required">{{
          $t('homework.date')
        }}</label>
        <div class="col-md-6">
          <a-date-picker
            style="width:100%"
            format="DD-MM-YYYY"
            v-model="model.homework_date"
          ></a-date-picker>
          <div class="validate" v-if="errors.has('homework_date')">
            {{ errors.first('homework_date') }}
          </div>
        </div>
      </div>
      <div class="row form-group">
        <label class="col-form-label col-md-4 required">{{
          $t('homework.class')
        }}</label>
        <div class="col-md-6">
          <a-select
            v-model.number="model.class_id"
            style="width:100%"
            :options="class_list"
            :show-search="true"
            option-filter-prop="children"
            :filter-option="
              (input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
            "
            @change="onClassChange"
          ></a-select>
          <div class="validate" v-if="errors.has('class_id')">
            {{ errors.first('class_id') }}
          </div>
        </div>
      </div>
      <div class="row form-group">
        <label class="col-form-label col-md-4 required">{{
          $t('homework.subject')
        }}</label>
        <div class="col-md-6">
          <a-select
            style="width:100%"
            :options="subject_list"
            v-model.number="model.subject_id"
          ></a-select>
          <div class="validate" v-if="errors.has('subject_id')">
            {{ errors.first('subject_id') }}
          </div>
        </div>
      </div>
      <div class="row form-group">
        <label class="col-form-label col-md-4 required">{{
          $t('homework.submissionEnddate')
        }}</label>
        <div class="col-md-6">
          <a-date-picker
            v-model="model.submission_end_date"
            style="width:100%"
            format="DD-MM-YYYY"
          ></a-date-picker>
          <div class="validate" v-if="errors.has('submission_end_date')">
            {{ errors.first('submission_end_date') }}
          </div>
        </div>
      </div>
      <div class="row form-group">
        <label class="col-form-label col-md-4">{{
          $t('homework.remark')
        }}</label>
        <div class="col-md-6">
          <textarea
            v-model="model.remarks"
            rows="3"
            class="form-control"
          ></textarea>
        </div>
      </div>
      <div class="row form-group">
        <label class="col-form-label col-md-4">{{
          $t('homework.referenceVideo')
        }}</label>
        <div class="col-md-6">
          <div class="input-group mb-3">
            <input
              v-model.trim="url"
              type="text"
              class="form-control"
              aria-describedby="basic-addon2"
            />
            <div class="input-group-append">
              <button
                class="btn btn-outline-secondary"
                type="button"
                @click.prevent="addUrl"
              >
                <i class="fa fa-plus"></i>
              </button>
            </div>
          </div>
          <div class="mt-3">
            <table style="width:100%">
              <tr v-for="(refer, index) in model.reference_url" :key="index">
                <td>
                  <a href="#">{{ refer.url }}</a>
                </td>
                <td class="text-right">
                  <a href="#" class="text-red">
                    <i
                      class="fa fa-times"
                      @click.prevent="removeUrl(index)"
                    ></i>
                  </a>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-md-4"></div>
        <div class="col-md-6 text-right">
          <slot name="button-action"></slot>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'TeacherHomeworkCreateForm',
  props: ['value', 'validate'],
  data() {
    return {
      errors: new Errors(),
      url: null,
      loading: false,
      teacherList: [],
      class_list: [],
      subject_list: [],
      model: {}
    }
  },
  computed: {
    ...mapState('eschool/teacherHomework', ['edit_data']),
    isEdit() {
      return !_.isEmpty(this.edit_data) && this.edit_data !== undefined
    }
  },
  created() {
    this.model = this.value
    this.loadClass()
    this.setEdit()
  },
  methods: {
    addUrl() {
      if (!this.url) return
      this.model.reference_url.push({
        url: this.url
      })
      this.url = null
    },
    removeUrl(index) {
      this.model.reference_url.splice(index, 1)
    },
    loadClass() {
      if (!this.isEdit) {
        this.class_list = []
        this.subject_list = []
        this.model.class_id = null
        this.model.subject_id = null
      }
      this.loading = true
      this.$store
        .dispatch('eschool/teacherHomework/getClass')
        .then(response => {
          this.class_list = response.data.map(el => ({
            value: el.class_id,
            label: el.class_name
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onClassChange() {
      if (!this.isEdit) {
        this.subject_list = []
        this.model.subject_id = null
      }
      this.loading = true
      this.$store
        .dispatch('eschool/teacherHomework/getSubject', { ...this.model })
        .then(response => {
          this.subject_list = response.data.map(el => ({
            value: el.subject_id,
            label: el.subject_name
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async setEdit() {
      if (!_.isEmpty(this.edit_data) && this.edit_data !== undefined) {
        this.model.homework_date = moment(
          this.edit_data.homework_date,
          'DD-MM-YYYY'
        )
        this.model.class_id = this.edit_data.class_id
        this.model.subject_id = this.edit_data.subject_id
        this.model.remarks = this.edit_data.remarks
        this.model.submission_end_date = moment(
          this.edit_data.submission_end_date,
          'DD-MM-YYYY'
        )
        this.model.reference_url = JSON.parse(this.edit_data.url_reference)
          ? JSON.parse(this.edit_data.url_reference)
          : []
        this.model.attach_file_list = this.edit_data.homework_attachment.map(
          el => ({
            attach_file_name: el.attach_file_name,
            attach_file_path: el.attach_file_path,
            mime_type: el.attach_file_mime_type,
            file_type: el.attach_file_type
          })
        )
        await this.onClassChange()
      }
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
